// extracted by mini-css-extract-plugin
export default {"change-password":"ChangePassword_change-password__giCIg"};